module.exports = __webpack_public_path__ + "u16.no2.06459df8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/u16.no2.jpg
// module id = OfwS
// module chunks = 0